import { bl_crm_risk_spending_limit_alarm_hdr_RowClass } from '../../..';
import {BaseContainerModel} from '../../base-container.model';

export class SpendingLimitAlarmContainerModel extends BaseContainerModel {
    bl_crm_risk_spending_limit_alarm_hdr: bl_crm_risk_spending_limit_alarm_hdr_RowClass = new bl_crm_risk_spending_limit_alarm_hdr_RowClass();
}